import React, { useEffect, useMemo, useState } from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'

import TabsMui from '../../layout/TabsMui'
import { layoutMobileMediaQuery } from '../../layout/layoutConstants'

import NoEffectiveVisitModernDetailsTab from './NoEffectiveVisitModernDetailsTab'
import {
  buildNoEffectiveVisitTabs,
  NO_EFFECTIVE_VISIT_STATUS_UI_MAP,
  NO_EFFECTIVE_VISIT_TAB_VALUES
} from './shared/noEffectiveVisitConstants'

export default function ShowNoEffectiveVisitView({ details, defaultDetails }) {
  const [activity, setActivity] = useState(defaultDetails)
  const [activeTab, setActiveTab] = useState(NO_EFFECTIVE_VISIT_TAB_VALUES.VISIT)
  const isMobileLayout = useMediaQuery(layoutMobileMediaQuery)

  useEffect(() => {
    setActivity(defaultDetails)
  }, [defaultDetails])

  const tabs = useMemo(() => buildNoEffectiveVisitTabs(), [])
  const statusUI = NO_EFFECTIVE_VISIT_STATUS_UI_MAP?.[activity?.status] || null

  if (!activity) return null

  return (
    <>
      <div className="main-show-header">
        <h2>Visita no efectiva: {activity?.no_effective_visit_db_ref}</h2>
      </div>
      <div className="index-table">
        <div className="show-area">
          <div className="show-area-tabs-header">
            <TabsMui
              tabs={tabs}
              activeTab={activeTab}
              onChange={setActiveTab}
              scrollable={false}
              showDivider={false}
              marginBottom={0}
            />
            {!isMobileLayout && (
              <div className="status-orders">
                <b className="order-status-b">Estado:</b>
                <span className={`order-status ${statusUI?.className || ''}`}>
                  {statusUI?.label || activity?.status || '-'}
                </span>
              </div>
            )}
          </div>

          <div className="tab-content-area">
            {activeTab === NO_EFFECTIVE_VISIT_TAB_VALUES.VISIT && (
              <NoEffectiveVisitModernDetailsTab
                activity={activity}
                statusUI={statusUI}
                showStatusInHeader={isMobileLayout}
              />
            )}
          </div>
        </div>
      </div>
    </>
  )
}
